import { render } from "./LogoutPopup.vue?vue&type=template&id=ed376c1a"
import script from "./LogoutPopup.vue?vue&type=script&lang=js"
export * from "./LogoutPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__